if (!customElements.get('fetch-reviews')) {
  customElements.define(
    'fetch-reviews',
    class FetchReviews extends HTMLElement {
      constructor() {
        super();
        this.contentContainer = this.querySelector('[data-container]');
        this.button = this.querySelector('[data-readmore-button]');
        this.productId = this.dataset.productId;
        this.reviewsPerPage = +this.dataset.reviewsPerPage;
        this.page = 1;
        this.totalReviewsCount = +this.dataset.totalReviewsCount;

        this.button.addEventListener('click', () => this.onFetchReviews(this.productId, this.contentContainer, this.page, this.reviewsPerPage))
      }

      connectedCallback() {
        this.onFetchReviews(this.productId, this.contentContainer, this.page, this.reviewsPerPage);
      }

      async onFetchReviews(productId, container, page, reviewsPerPage) {
        const curentAmountOfReviews = page * reviewsPerPage;
        if(curentAmountOfReviews >= this.totalReviewsCount) {
          this.button.classList.add('hidden');
          this.button.setAttribute('disabled', true);
          return;
        }
        this.button.classList.add('loading');
        //url to template with reviews
        const url = `https://api.judge.me/reviews/reviews_for_widget?url=i7hskj-mh.myshopify.com&shop_domain=i7hskj-mh.myshopify.com&platform=shopify&page=${page}&per_page=${reviewsPerPage}&product_id=${productId}`;

        try {
          //fetch request
          const response = await fetch(url);

          //handling error
          if (!response.ok) throw new Error('Failed to fetch HTML content');

          //parsing data
          const data = await response.json();
          const parser = new DOMParser();
          const htmlContent = parser.parseFromString(data.html, 'text/html');
          const reviews = htmlContent.querySelectorAll('.jdgm-rev');

          reviews.forEach((review) => {
            //getting needed content
            const reviewsScore = review.querySelector('.jdgm-rev__rating').dataset.score;
            const reviewTitle = review.querySelector('.jdgm-rev__title').innerText;
            const reviewBody = review.querySelector('.jdgm-rev__body').innerText;
            const reviewDate = new Intl.DateTimeFormat("en-US").format(new Date(review.querySelector('.jdgm-rev__timestamp').dataset.content))
            const reviewAuthorName = review.querySelector('.jdgm-rev__author').innerText;

            //handling conditions
            // const isVerified = review.querySelector('.jdgm-rev__source') || review.querySelector('.jdgm-rev__buyer-badge');

            const reviewHTML = `
              <div class="reviews-item">
                <div class="reviews-userinfo">
                  <div class="reviews-verified">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                      <mask id="mask0_1_30770" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
                        <rect width="19" height="19" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_1_30770)">
                        <path d="M8.39159 13.1418L13.9728 7.56058L12.8645 6.45225L8.39159 10.9252L6.13533 8.66891L5.027 9.77725L8.39159 13.1418ZM9.49992 17.4168C8.40478 17.4168 7.37561 17.209 6.41242 16.7934C5.44922 16.3778 4.61138 15.8137 3.89888 15.1012C3.18638 14.3887 2.62231 13.5509 2.20669 12.5877C1.79106 11.6245 1.58325 10.5953 1.58325 9.50016C1.58325 8.40502 1.79106 7.37586 2.20669 6.41266C2.62231 5.44947 3.18638 4.61162 3.89888 3.89912C4.61138 3.18662 5.44922 2.62256 6.41242 2.20693C7.37561 1.79131 8.40478 1.5835 9.49992 1.5835C10.5951 1.5835 11.6242 1.79131 12.5874 2.20693C13.5506 2.62256 14.3885 3.18662 15.101 3.89912C15.8135 4.61162 16.3775 5.44947 16.7931 6.41266C17.2088 7.37586 17.4166 8.40502 17.4166 9.50016C17.4166 10.5953 17.2088 11.6245 16.7931 12.5877C16.3775 13.5509 15.8135 14.3887 15.101 15.1012C14.3885 15.8137 13.5506 16.3778 12.5874 16.7934C11.6242 17.209 10.5951 17.4168 9.49992 17.4168Z" fill="#231F20"/>
                      </g>
                    </svg>
                    <span>Verified Customer</span>
                  </div>
                  <div class="reviews-userinfo__main">
                    <h4 class="reviews-userinfo__name">${reviewAuthorName}</h4>
                    <p class="reviews-userinfo__date">${reviewDate}</p>
                  </div>
                </div>
                <div>
                  <div class="main-product__review-stars">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M3.20344 16.75L5.15063 10.385L0 6.70001H6.36501L8.37501 0L10.385 6.70001H16.75L11.5994 10.385L13.5466 16.75L8.37501 12.8138L3.20344 16.75Z" fill="#231F20"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M3.20344 16.75L5.15063 10.385L0 6.70001H6.36501L8.37501 0L10.385 6.70001H16.75L11.5994 10.385L13.5466 16.75L8.37501 12.8138L3.20344 16.75Z" fill="#231F20"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M3.20344 16.75L5.15063 10.385L0 6.70001H6.36501L8.37501 0L10.385 6.70001H16.75L11.5994 10.385L13.5466 16.75L8.37501 12.8138L3.20344 16.75Z" fill="#231F20"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M3.20344 16.75L5.15063 10.385L0 6.70001H6.36501L8.37501 0L10.385 6.70001H16.75L11.5994 10.385L13.5466 16.75L8.37501 12.8138L3.20344 16.75Z" fill="#231F20"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M3.20344 16.75L5.15063 10.385L0 6.70001H6.36501L8.37501 0L10.385 6.70001H16.75L11.5994 10.385L13.5466 16.75L8.37501 12.8138L3.20344 16.75Z" fill="#231F20"/>
                    </svg>
                  </div>
                    <h5 class="reviews-title">${reviewTitle}</h5>
                    <div class="reviews-body">${reviewBody}</div>
                </div>
              </div>
            `;
            if (container) {
              //parsing string into element via temporary div
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = reviewHTML;
              const reviewElement = tempDiv.firstElementChild;

              const stars = reviewElement.querySelectorAll('.main-product__review-stars svg');
              const toUnfill = 5 - reviewsScore;

              // apply white + stroke to the last N stars
              for (let i = 0; i < toUnfill; i++) {
                const star = stars[stars.length - 1 - i];
                const path = star.querySelector('path');
                path.setAttribute('fill', 'white');
                path.setAttribute('stroke', 'black');
                path.setAttribute('stroke-width', '1.2');
              }

              // Append the element to the container
              container.appendChild(reviewElement);
            }
          });
        } catch (error) {
          console.error('Error fetching content:', error);
          this.button.classList.remove('loading');
        } finally {
          this.page += 1;
          this.button.classList.remove('loading');
        }
      }
    }
  );
}